import IJitRepository from '../domain/IJitRepository';
import jitRepository from '../infrastructure/repositories/JitRepository';

class GetRemarksService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute(queryParams: {
    code: any;
    provider_id: number;
    provider_tier: string;
    fromDate: string;
  }) {
    return this._jitRepository
      .getJitRemarksByPiece({ queryParams })
      .then((res) => res)
      .catch((error: any) => {
        // Si es 404, devolver lista vacía
        if (error.message === 'Error: 404') {
          return [];
        }

        // Propagar otros errores
        throw error;
      });
  }
}

export default new GetRemarksService({ repository: jitRepository });

export { GetRemarksService };
